import { QueryClient } from '@tanstack/react-query';

// Single app-wide React Query client. Mounted by QueryProvider; import here
// (not a new QueryClient) anywhere non-hook code needs cache access.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Data is considered fresh for 1 minute; socket events and mutation
      // onSuccess handlers invalidate the affected keys explicitly.
      staleTime: 60 * 1000,
      gcTime: 10 * 60 * 1000,
      retry: (failureCount, error) => {
        if (error?.category === 'validation' || error?.category === 'auth') {
          return false;
        }
        return failureCount < 2;
      },
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});

export default queryClient;
